import { TranslateService } from '@ngx-translate/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Component, OnInit } from '@angular/core';
import { UserApiService } from 'src/app/user-api.service';
import { UserApi } from 'src/app/models/api_models/user';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';

@Component({
  selector: 'app-user-edit-profil',
  templateUrl: './user-edit-profil.component.html',
  styleUrls: ['./user-edit-profil.component.css']
})



export class UserEditProfilComponent implements OnInit {

  //private regex : RegExp = new  RegExp("/^(?:(?:\+|00)33|0)\s*[1-9](?:[\s.-]*\d{2}){4}$");

  public loaded = false;
  public currentUser: UserApi = null;


  UpdataUserProfil() {
    this.loaded = false;

    console.log(this.currentUser.phonenumber)

    if (this.currentUser.phonenumber == null) {
      this.openSnackBar(this.translate.instant('ERREURPROFIL.TEL'))
      setTimeout(function(){ location.reload() }, 2000);

    } else {

      this.userService.updateUser(this.currentUser).subscribe(
        response => {
          this.router.navigate(['/user']);
        },
        error => {
  
        }
      );

    }

 
  }

  public getUserImg() {
    if (this.currentUser.profile_picture !== null) {
      return this.sanitizer.bypassSecurityTrustUrl(`data:${this.currentUser?.profile_picture.mimetype};base64,${this.currentUser?.profile_picture.file}`)
    }
  }

  constructor(private translate: TranslateService, public snackBar: MatSnackBar, public sanitizer: DomSanitizer, private userService: UserApiService, public domSanitizer: DomSanitizer, private router: Router) { }

  ngOnInit() {
    this.userService.getCurrentUserData().subscribe(response => {
      this.currentUser = response;
      this.getUserImg()
      this.loaded = true;
      // conswarn(response);
      // conslog(response);

    },
      error => {
        // conserror(error);
      });

  }



  openSnackBar(message: string) {
    this.snackBar.open(message, "X", {
      panelClass: ['blue-snackbar'],
      duration: 2000,
    });
  }





}
